import React, { memo } from 'react';
import pt from 'prop-types';
import Status from 'components/status';
import { REVIEW_STATUS } from 'shared/app-versions';

function AppVersionStatus({ app, version = null, blank = false }) {
  const { staged_props, published_props } = app;
  const stagedVersion = staged_props?.version;
  const publishedVersion = published_props?.version;
  const reviewStatus = version?.review_status;
  const published = version?.published || false;
  // A version can stay marked `published` after a newer version replaces it;
  // only the current published version should be highlighted
  const isLatestPublished = published && version?.version === publishedVersion;
  const released = version?.released || false;
  const staged = stagedVersion && version?.version === stagedVersion;
  const rejected = reviewStatus === REVIEW_STATUS.REJECTED;
  const needsChanges = reviewStatus === REVIEW_STATUS.NEEDS_CHANGES;
  const inReview = reviewStatus === REVIEW_STATUS.IN_REVIEW;

  return (
    <Status
      type={
        rejected
          ? 'negative'
          : isLatestPublished
          ? 'positive'
          : published
          ? 'muted'
          : staged || inReview || needsChanges
          ? 'warning'
          : released
          ? 'primary'
          : 'muted'
      }
      blank={blank}
    >
      {rejected
        ? 'Rejected'
        : published
        ? 'Published'
        : inReview
        ? 'In review'
        : needsChanges
        ? 'Needs changes'
        : staged
        ? 'Staged'
        : released
        ? 'Released'
        : 'Unreleased'}
    </Status>
  );
}

AppVersionStatus.propTypes = {
  app: pt.object,
  version: pt.object,
  blank: pt.bool,
};

export default memo(AppVersionStatus);
